<template>
  <!-- @drop="seupFun" -->
  <!-- 影响图片拖拽到富文本 先注释 -->
  <div
    class="application-rout"
    :class="showModal ? 'rout-opendialog' : ''"
    @dragover="moveFun($event)"
    @dragend="mouseFun($event)"
  >
    <template v-if="isBatchAddPage">
      <div class="batch-add">
        <batchAdd :isConfig="false" @close="$emit('close')" :property="property" ref="batchAdd" :queryData="queryData" :animationStyle="animationStyle" :customData="customData" :config="batchAddInfo" :batchAddStyle="batchAddStyle" :appInfo="{ id: approvalId, fileProperty }" />
        <div class="batch-add-btn">
          <el-button type="primary" size="mini" @click="saveBatchAdd">保存</el-button>
        </div>
      </div>
    </template>
    <template v-else>
      <template v-if="customPage" >
        <!-- 自定义的列表页面 -->
        <list-design
          :cardConfig="customPageConfig.info.cardConfig"
          :dataInfo ="customPageConfig"
          :isAppDesign="true"
          :organizationType="organizationType"
          :aitableHide="aitableHide"
          ></list-design>
      </template>
      <template v-else-if="isView">
        <div v-if="$route.query.approvalId && !external && navShow">
          <oa-frame-nav perviousUrl="1"></oa-frame-nav>
        </div>
        <div
          class="application-nav"
          :class="navIndex === 4 ? 'pad-123' : ''"
          :style="
            $route.query.approvalId && !external && navShow ? 'top:76px;' : ''
          "
          v-show="!customDeskInfo.iId && !$route.query.iId"
        >
          <div
            class="nav-list"
            :class="navIndex === 1 ? 'list-active' : ''"
            @click="upUrl(1)"
            v-if="
              (list.approvalid && !list.myreportformid) ||
              (external && list.approvalid)
            "
          >
            填写
          </div>
          <div
            class="nav-list"
            :class="navIndex === 2 ? 'list-active' : ''"
            @click="upUrl(2)"
            v-if="list.myreportformid"
          >
            <!--          <i class="iconfont icon-yonghuming" v-show="navIndex === 2" />-->
            个人数据
            <i
              class="nav-list-right-sj iconfont icon-gengduo"
              v-show="navIndex === 2 && showArrowBtn"
            ></i>
            <div class="nav-list-list" v-show="navIndex === 2 && isTop && showArrowBtn">
              <template v-for="(item, index) in listAuthority" :key="'menu' + index">
                <div
                  class="nav-list-list-list"
                  ref="navList"
                  :class="item.check ? 'active' : ''"
                  @click.stop.prevent="uplist(item.key, index)"
                  v-if="!item.hide"
                >
                  {{ item.name }}
                  <span class="icon-red" v-if="listCount[item.name]">{{ listCount[item.name] }}</span>
                </div>
              </template>
            </div>
          </div>
          <div
            class="nav-list"
            :class="[3, 6, 8].includes(navIndex) ? 'list-active' : ''"
            @click="upUrl([3, 6, 8].includes(navIndex) ? undefined : !list.reportFormid && list.scopeid ? 6 : 3)"
            v-if="list.reportFormid || list.scopeid"
          >
            {{ !list.reportFormid && list.scopeid ? "管辖数据" : "全部数据" }}
            <template v-if="list.reportFormid && list.scopeid">
              <i class="nav-list-right-sj iconfont icon-gengduo" v-show="[3, 6, 8].includes(navIndex)"></i>
              <div class="nav-list-list" v-show="[3, 6, 8].includes(navIndex) && isTops">
                <div class="nav-list-list-list" :class="navIndex === 3 ? 'active' : ''" ref="allData" @click.stop.prevent="upUrl(3, false, true)">
                  全部数据
                </div>
                <div class="nav-list-list-list" ref="precinctData" :class="navIndex === 6 ? 'active' : ''" @click.stop.prevent="upUrl(6, false, true)">
                  管辖数据
                </div>
                <div class="nav-list-list-list" ref="precinctData" :class="navIndex === 8 ? 'active' : ''" @click.stop.prevent="upUrl(8, false, true)">
                  回收站
                </div>
              </div>
            </template>
          </div>
          <el-popover
            placement="bottom"
            width="112"
            popper-class="assessment-popper"
            @show="allClose"
            trigger="click"
          >
            <template #reference>
              <div class="mom-button">
                <i v-if="getTaskHint.count > 0" class="icon-round" />更多功能<i
                  class="iconfont icon-gengduo"
                />
              </div>
            </template>
            <div class="mom-block">
              <div class="mom-block-list" @click="upUrl(7)" ref="applyTask">
                <i v-if="getTaskHint.count > 0" class="icon-round" />应用任务
              </div>
              <div
                v-if="list.uncompleteid"
                ref="sumbit"
                :class="['mom-block-list', navIndex === 4 ? 'active' : '']"
                @click="upUrl(4)"
              >
                提交统计
              </div>
              <div
                v-if="list.blockchainid"
                ref="blockChain"
                :class="['mom-block-list', navIndex === 5 ? 'active' : '']"
                @click="upUrl(5)"
              >
                区块链统计
              </div>
            </div>
          </el-popover>
        </div>
        <div class="input-center" v-if="navIndex === 1">
          <img
          v-show="notaskShow"
            src="https://bigdata.topeti.com/PCRepository/defaultSvg/NoTask.svg"
            class="no-input"
          />
          <el-button
            v-if="list.approvalid && notaskShow"
            size="mini"
            type="yeprimary"
            class="input-button"
            @click="openInput"
            >填写</el-button
          >
        </div>
        <!-- 填写的直接挂在本页面，其他的用iframe 打开 -->
        <!-- style="width: 100%; height: 100%; position: relative"
          :style="$route.query.approvalId ? 'height: calc(100% - 90px)' : ''" -->
        <div
          class="showDatas"
          :style="
            $route.query.approvalId
              ? navShow === true
                ? 'height: calc(100% - 80px);margin-top:10px;'
                : 'height: calc(100% )'
              : ''
          "
          v-show="(navIndex > 1 && urlArr.length > 0) || taskDialog"
        >
          <template v-for="list in urlArr" :key="list.id">
            <transactionManagement
              v-if="list.key === 2"
              v-show="list.show"
              :listCount="listCount"
              ref="transactionCenter"
              @open-appDialog="openAppDialog"
              @upInput="upInput"
              @refershRed="getapprovalnum"
              @retRefresh="retRefresh"
              :external="external"
              :batchadd="batchadd"
              :fileProperty="fileProperty"
              :importSet="importSet"
              :aitableHide="aitableHide"
            />
            <transactionManagements
              v-else-if="list.key === 3"
              v-show="list.show"
              ref="transactionCenters"
              :appid="approvalId"
              :externals="external"
              :fileProperty="fileProperty"
              :importSet="importSet"
              :aitableHide="aitableHide"
              @open-appDialog="openAppDialog"
              @upInput="upInput"
              @retRefresh="retRefresh"
            />
            <RecycleBin v-else-if="list.key === 8"
              ref="RecycleBin"
              v-show="list.show"
              :appid="approvalId"
              @retRefresh="retRefresh"
            />
            <transactionScope
              v-else-if="list.key === 6"
              v-show="list.show"
              :key="list.id"
              ref="transactionScope"
              :appid="approvalId"
              :externals="external"
              :importSet="importSet"
              @open-appDialog="openAppDialog"
              @upInput="upInput"
              @retRefresh="retRefresh"
            />
            <iframe
              @load="iframeAreadys"
              v-else
              v-loading="iframeLoading"
              frameborder="0"
              scrolling="auto"
              :ref="'iframe' + list.key"
              v-show="list.show"
              :key="list.key"
              :src="list.url"
              allowtransparency="true"
            ></iframe>
          </template>
          <!-- 这个是固定弹出应用任务的 所以写死 -->
          <el-dialog
            v-if="taskDialog"
            v-model="taskDialog"
            :fullscreen="taskEnlarge"
            class="task-Routing"
            width="1224px"
          >
            <template #header>
              <div class="task-routing-title">
                <div class="title-title">我发布的任务</div>
                <i
                  :class="[
                    'iconfont task-icon',
                    taskEnlarge ? 'icon-suoxiao1' : 'icon-fangda2',
                  ]"
                  @click="taskEnlarge = !taskEnlarge"
                />
              </div>
            </template>
            <dialogIndex
              :taskInfo="
                JSON.stringify({ name: name, id: approvalId, datatype: 1 })
              "
              :style="
                taskEnlarge ? 'height: calc(100vh - 38px);' : 'height: 605px;'
              "
            />
          </el-dialog>

          <!--      <iframe id="iframe" @load="iframeAready" v-loading="iframeLoading" frameborder=0 scrolling=auto :src="url" allowtransparency="true"></iframe>-->
        </div>

        <!-- 提交统计 -->
        <el-dialog v-model="statistics" v-if="statistics" :fullscreen="statisticsEnlarge" class="task-Routing" width="1224px">
          <template #title>
            <div class="task-routing-title">
              <div class="title-title">提交统计</div>
              <i
                :class="[
                    'iconfont task-icon',
                    statisticsEnlarge ? 'icon-suoxiao1' : 'icon-fangda2',
                  ]"
                @click="statisticsEnlarge = !statisticsEnlarge"
              />
            </div>
          </template>
          <iframe v-dhtLoading="iframeLoading"
                  :style="
                statisticsEnlarge ? 'height: calc(100vh - 38px);' : 'height: 605px;'
              "
                  frameborder="0"
                  scrolling="auto"
                  :src="'/clientSide/workbench/CycleFillingSetting/CycleFillingSetting?approvalId=' + approvalId"
                  allowtransparency="true"></iframe>
        </el-dialog>
      </template>
    </template>
    <!-- 填写弹框 -->
     <!-- 加上 append-to-body  门户菜单栏目不加的话 遮罩层会在新增弹层的上面 -->
    <el-dialog
      v-model="isInput"
      :destroy-on-close="true"
      :show-close="false"
      :modal="false"
      :append-to-body="true"
      :close-on-click-modal="false"
      :class="pdheight== 'auto' ? 'application-routing-dialog-all dialog-height-auto' : 'application-routing-dialog-all'"
      :fullscreen="routingFlowshow"
      :top="isSubmit ? '-100vh' : routingFlowshow ? '0' : '8.9vh'"
      :width="routingFlowshow ? '100%' : (pdwidth + '%')"
      :style="showLink ? 'display:none' : ''"
    >
      <div :class="['dialog-top', isfaceAr !== 0 ? 'dialog-top-black' : '']">
        <div class="apply-name">{{ name }}</div>
        <div class="apply-right">
          <div class="face-ar" v-if="isfaceAr !== 0">
            <span
              class="active-hover"
              @click="faceArChange"
            >
              <i
                v-show="isfaceAr === 1"
                class="iconfont icon-AR1"
                style="font-size: 20px"
              />
              <i
                v-show="isfaceAr === 2"
                class="iconfont icon-AR"
                style="font-size: 20px"
              />
            </span>
          </div>
          <div v-if="isAi && aiStatus" class="active-hover" @click="upIsAi(isAi === 1 ? 2 : 1)"
           :style="{color: isAi === 1 ? '#4e86ff' : ''}">
            <img src="https://bigdata.topeti.com/PCRepository/mainPlatform/ai.png" style="width:25px;height:25px;vertical-align: inherit;margin-right:4px;" />
            AI小易
          </div>
          <div v-if="flowshow != 2 && !modify">
            <span class="active-hover" @click="onFlowshow">
              <el-icon style="float:left;margin:15px 3px 0 0;"><View /></el-icon>
              {{ getFlowShowText() }}
            </span>
          </div>
          <div>
            <span
              class="active-hover"
              style="margin-right: 5px"
              @click="routingFlowshow = !routingFlowshow"
            >
              <i
                v-show="!routingFlowshow"
                class="iconfont icon-fangda2"
                style="font-size: 14px"
              />
              <i
                v-show="routingFlowshow"
                class="iconfont icon-suoxiao1"
                style="font-size: 14px"
              />
            </span>
            <span class="active-hover" @click="isInput = false">
              <i class="icon iconfont icon-shanchu3" />
              <!--                关闭-->
            </span>
          </div>
        </div>
      </div>
      <!-- 这边需要添加一个传进来的参数下去给发起作为默认值之后的覆盖值使用 -->
      <oaExamineInput
        :external="external"
        :approvalId="approvalId"
        :modify="modify"
        :person="navIndex === 2 ? 1 : 0"
        :coverVal="coverVal"
        v-model:isAi="isAi"
        v-model:pdwidth="pdwidth"
        type="1"
        ref="AuditOpenInput"
        @hideLink="hideLink"
        @refFlowshow="refFlowshow"
        @retRefresh="retRefresh"
        @inputClose="inputClose"
        @getfaceAr="getfaceAr"
        @upIsAi="upIsAi"
        @upIsPcwidth="upIsPcwidth"
        @upIsPcHeight="upIsPcHeight"
        @loadSuccess="loadSuccess"
        @beginSubmit="isSubmit = false"
        v-if="isInput"
      />
    </el-dialog>
          <!-- 个人数据、填写同时存在权限 -->
          <div
        v-show="
          ($route.query.iId == 12 ||
            $route.query.iId == 1 ||
            !$route.query.iId) &&
          list.approvalid &&
          list.myreportformid &&
          navIndex === 2 &&
          !external &&
          !taskDialog && !customPage
        "
        class="write"
        id="write"
        draggable="true"
        ref="write"
        @dragstart="mouseFun"
        @click="seupFun"
      >
        <div class="write-text" v-if="repeat && repeat.isEdit && !repeat.start">
          未填
        </div>
        <i class="iconfont icon-faqi" style="font-size: 18px;"></i>
        <div class="write-cent">新增</div>
      </div>
    <div v-html="cssFun()"></div>
    <app-dialog 
      :dialogInfo="dialogInfo"
    />
  </div>
</template>

<script>
import transactionManagement from './workbench/transactionManagement.vue'
import transactionManagements from './workbench/transactionManagements.vue'
import transactionScope from './workbench/transactionScope.vue'
import batchAdd from '../common/batchAdd.vue'
import oaFrameNav from './oaFrame/oaFrameCommon/oaFrameNav.vue'
import { openapiGetapprovalnum, openapiGetapproval } from '@/port/clientSide/applicationRouting'
import { getdepttiplist } from '@/port/admins/organizationUser'
import { getConfigFromUrl, isJSON } from "@/api/utils.js"
import { axiosBase } from '../../api/api';
import { getapprovaladdconfig } from '@/port/clientSide/oaExamineAudit'
import { isValidateapprovaltimeswitch } from '@/components/schoolInstrument/mixins/utils'
import RecycleBin from './workbench/recycleBin.vue'
import { defineAsyncComponent } from 'vue'
export default {
  name: "applicationRouting",
  // external 此参数代表外链
  props: {
    "external": {
      type: Boolean,
      default: false
    },
    //- 区块链数据
    "blockchainData": {
      type: String,
      default: ''
    },
    customDeskInfo:{
      type: Object,
      default: ()=>({})
    }
  },
  provide () {
    return {
      customDeskInfo: this.customDeskInfo,
    }
  },
  components: {
    transactionManagement,
    transactionManagements,
    transactionScope,
    batchAdd,
    RecycleBin, // 回收站
    oaExamineInput: defineAsyncComponent(() => import('./oaExamineInput.vue')),
    oaFrameNav,
    dialogIndex: defineAsyncComponent(() => import('@/views/mission/dialogIndex.vue')),
    ListDesign: defineAsyncComponent(() => import('@/components/schoolInstrument/component/mutual/index.vue')),
    AppDialog: defineAsyncComponent(() => import('@/components/schoolInstrument/mixins/AppDialog.vue')),
  },
  data () {
    return {
			aiStatus:false,
      isAi: 0,
      isfaceAr: 0, //0 未配置人脸识别 1 拍摄模式 2 AR模式
      pdwidth: 75,
      pdheight: 'regular',
      flowshow: 2,
      routingFlowshow: false, // true 放大 false 不放大
      source: '', // 来源
      approvalId: '',
      name: '',
      list: {},
      navIndex: 1,
      notaskShow: false, //权限图片是否显示
      urlArr: [], // 切换路由使用（数组是根据点击来添加的）
      urlObj: {},
      iframeLoading: false,
      isInput: false,
      guide: [],
      listCount: {}, // 红点提示
      modify: null, // 这个是修改的参数
      isView: false,  // 是否显示页面
      repeat: {}, // 未填提醒等提示

      // 屏幕信息
      viewHeight: 0,
      viewWidth: 0,
      isMobiles: false,  // 是否移动
      isMobilePass: false,  // 是否移动过
      //- 不同模式下是否显示导航条
      navShow: true,
      // 显示待我处理等列表
      listAuthority: [],
      scopeLimit: false, // 管辖范围权限是否开启
      isTop: false,
      isTops: true,
      activeName: 0,  //- 设置dom显示      4:全部,0:我发起的,3:关于我的,1:待办的,2:已办的 5代办 6 已办 7 待阅
      batchadd: false, // 是否开启批量审批
      // 任务应用
      taskDialog: false,
      taskEnlarge: false,
      // 提交统计
      statistics: false,
      statisticsEnlarge: false,
      // 覆盖值
      coverVal: '',
      customPage: false, // 自定义列表页面
      customPageConfig: {}, // 自定义列表页面配置
      organizationType: [], // 组织架构标签数据
      isSpace: false, // 是否从空间进入
      isUpace: false, // 是否从空间进入
      isSubmit: false, // 是否一键提交
      fileProperty: {}, // 该表的配置信息
      showModal: false, //是否显示遮罩层
      showLink: false, // 是否隐藏当前弹出窗口（但是不关闭）
      importSet: {}, // 导入设置
      dialogInfo: {},
      isBatchAddPage: false,
      batchAddInfo: {},
      batchAddStyle: 'table',
      queryData: {},
      aitableHide: false, // 是否ai小易配置了表格隐藏
      customData: [],
      property: [],
      animationStyle: null
    }
  },
  computed: {
    getTaskHint () {
      return this.$store.state.taskHint
    },
    showArrowBtn(){
      const showCount = this.listAuthority.reduce((count, item) => (!item.hide ? count + 1 : count), 0)
      return showCount > 1 ? true : false
    }
  },
  watch: {
    showModal (val) {
      console.log("showModal==",val,this.isInput);
      if (!val && this.isInput) {
        this.addMask();
      } else {
        this.removeMask();
      }
    },
    isInput (val) {
      console.log("isInput==",val,this.showModal);
      this.addMask();
      if (!val) {
        // 关闭就重置参数
        this.modify = null;
        this.routingFlowshow = false
        this.isAi = 0
        if(!this.showModal){
          this.removeMask();
        }
      }
    },
  },
  created () {
    let queryData = this.$route.query
    if (Object.keys(this.customDeskInfo).length !== 0) {
      queryData = {
        ...queryData,
        ...this.customDeskInfo
      }
    }
    const spaceId = queryData.spaceid
    const spaceStatus = queryData.space
    const upaceId = queryData.upaceid
    const upaceStatus = queryData.upace
    this.queryData = queryData
    if (typeof(spaceId) !== 'undefined' || spaceStatus){
      this.isSpace = true
    }
    else if (typeof(upaceId) !== 'undefined' || upaceStatus){
      this.isUpace = true
    }
    const isBatchAdd = Number.isNaN(Number(queryData.iId))
    if (queryData.iId && isBatchAdd) {
      this.isBatchAddPage = true
    }
    //- 判断不同模式下是否显示导航条
    if (queryData.navShow) {
      let navShow = queryData.navShow;
      if (typeof navShow === 'boolean') {
        this.navShow = navShow
      } else if (typeof navShow === 'string') {
        if (navShow === 'true') {
          this.navShow = true
        } else if (navShow === 'false') {
          this.navShow = false
        }

      }
    }
    // 如果头部不存在就直接使用 props 里的
    if (queryData.source) this.source = queryData.source;
    if (queryData.approvalId) {
      // 读取应用列表红点
      const obj = { approvalId: queryData.approvalId }
      if(this.isUpace){
        const upaceId = this.$route.query.upaceid || localStorage.getItem('upaceid')
        obj.upaceId = upaceId
      }
      this.$store.commit('getTaskHint', obj);
      // 头部存在去查询权限
      this.isView = false;
      this.approvalId = queryData.approvalId;
      this.getAppInfo();
    }
    if (queryData.token) {
      sessionStorage.setItem('temporaryToken', queryData.token)
    }
  },
  mounted () {
    this.getOrganizationType()
    let queryData = this.$route.query
    if (Object.keys(this.customDeskInfo).length !== 0) {
      queryData = {
        ...queryData,
        ...this.customDeskInfo
      }
    }
    if(queryData.tableHide){
      this.aitableHide = true
    }
    if (queryData.iId) {
      this.$nextTick(() => {
        // debugger
        setTimeout(() => {
          let { dataId, funId, addId, search } = queryData
          dataId = dataId || parseInt(dataId)
          funId = funId || parseInt(funId)
          if (search) {
            try {
              search = typeof search === 'string' ? JSON.parse(search) : search
            } catch (error) {
              const url = decodeURIComponent(window.location.href)
              const que = url.split('?')[1]
              let searchStr = que.slice(que.indexOf('search'), que.length)
              search = JSON.parse(searchStr.split('=')[1])
            }
            // 空直过滤（叶子确认搜索过来的值不能为空）
            for (const i in search) {
              if (!search[i] && search[i] !== 0) delete search[i]
            }
            this.coverVal = search
          }
          if (dataId) {
            if (dataId == 7) {
              this.$refs.allData?.click(3, false, true)
            } else if (dataId == 6) {
              this.$refs.precinctData?.click(6, false, true)
            }
          }

          if (funId) {
            if (funId == 9) {
              this.$refs.applyTask.click(7)
            } else if (funId == 8) {
              this.$refs.sumbit.click(4)
            } else if (funId == 10) {
              this.$refs.blockChain.click(5)
            }
          }
          if (addId) {
            if (this.list.approvalid &&
              this.list.myreportformid &&
              this.navIndex === 2 &&
              !this.external &&
              !this.taskDialog) {
              this.$refs.write.click()
            }
          }
        }, 1000);
      })
    }
		this.getManagementList()
  },
  methods: {
    async saveBatchAdd() {
      await this.$refs.batchAdd.submit()
    },
    openAppDialog (val) {
      this.dialogInfo = val
    },
    getFlowShowText () {
      let str = '流程'
      if (this.applyInfo && this.applyInfo.baseset) {
        const baseset = typeof this.applyInfo.baseset === 'string' ? JSON.parse(this.applyInfo.baseset) : this.applyInfo.baseset
        if (baseset.flowshow && baseset.flowshow.type) {
          if (baseset.flowshow.viewText) {
            str = baseset.flowshow.viewText
          } else {
            str = baseset.flowshow.type === 'dialogue' ? '交流' : '流程'
          }
        }
      }
      return str
    },
    hideLink () {
      this.showLink = true
    },
    async getOrganizationType() {
      // 组织类型
      const { data, code, msg } = await getdepttiplist({
        curpage: 1,
        pagesize: 9999
      })
      if (code === 0) {
        this.organizationType = data
      } else {
        this.$message.error(msg)
      }
    },
    upIsPcwidth (val) {
      this.pdwidth = val
    },
    upIsPcHeight(val){
      this.pdheight = val
    },
    // 弹窗完成加载
    loadSuccess(){
      console.log('弹窗完成加载',this.showModal)
      setTimeout(() => {
        this.showModal = false
      }, 300);
    },
    upIsAi (val) {
      this.isAi = val
    },
    allClose () {
      this.isTop = false
      this.isTops = false
    },
    // 获取人脸识别是否打开
    getfaceAr(val){
      this.isfaceAr = val
      if(this.isfaceAr !== 0){
        this.routingFlowshow = true
      }
      else{
        this.routingFlowshow = false
      }
      console.log("this.isfaceAr==",this.isfaceAr);
    },
    // 切换人脸识别模式
    faceArChange(){
      this.isfaceAr = this.isfaceAr === 1 ? 2 : 1
      this.$refs.AuditOpenInput.faceArChange(this.isfaceAr)
    },
    cssFun () {
      const str = '<style>html, body, #app {height:100%;}</style>';
      return str;
    },
    refFlowshow (res) { // 子集
      this.flowshow = res
    },
    onFlowshow () {
      this.flowshow = this.flowshow ? 0 : 1
      this.$refs.AuditOpenInput.flowshow = this.flowshow
    },
    uplist (key, index) {
      console.log(key, index, 'key, index');
      if (this.listAuthority[index].check) return false;
      this.listAuthority = this.listAuthority.map((val, i) => {
        val.check = i === index
        return val
      })
      const dom = this.$refs.transactionCenter
      if (dom[0] && dom[0].inquire) {
        dom[0].inquire(key)
      } else {
        dom.inquire(key)
      }
    },
    upTopFun (key) {
      if (key === 2) {
        this.isTop = !this.isTop
      } else {
        this.isTops = !this.isTops
      }
    },
    /** 拖动事件 stat **/
    mouseFun () {
      if (this.taskDialog) return;
      this.viewHeight = window.innerHeight;
      this.viewWidth = window.innerWidth;
      this.isMobiles = true;
    },
    moveFun (e) {
      if (this.isMobiles && !this.taskDialog) {
        event.preventDefault();
        this.isMobilePass = true;
        let dom = document.getElementById('write');
        const left = e.clientX - 330;
        const bottom = this.viewHeight - e.clientY - 180;
        let str = 'transform: translate(' + left + 'px, ' + (bottom > 0 ? ('-' + bottom) : Math.abs(bottom)) + 'px);';
        dom.style = str;
      }
    },
    seupFun() {
      if (!this.isMobilePass && !this.taskDialog) this.openInput();
      this.isMobilePass = false;
      this.isMobiles = false;
    },
    /** 拖动事件 end **/
    // 修改打开
    upInput (e) {
      if(this.showModal) return false;
      this.showModal = true
      this.modify = e;
      this.isInput = true;
    },
    // 打开填写页面
    async openInput() {
      if(this.showModal) return false;
      this.showModal = true
      const payload = { type: 1, approvalId: this.approvalId }
      const upaceId = this.isUpace ? (this.$route.query.upaceid || localStorage.getItem('upaceid')) : undefined
      const flag = await isValidateapprovaltimeswitch(payload, upaceId)
      if (flag) {
        this.showModal = false
        return
      }
      this.isInput = false
      await this.$nextTick()
      let obj = { approvalId: this.approvalId }
      if(this.isUpace){
        const upaceId = this.$route.query.upaceid || localStorage.getItem('upaceid')
        obj.upaceid = upaceId;
      }
      let { code, data } = await getapprovaladdconfig(obj)
      if (code == 0 && data && JSON.stringify(data) !== '{}') {
        data = JSON.parse(data)
        this.isSubmit = data.isSubmit
      }
      this.isInput = true;
    },
    // 关闭input
    inputClose () {
      this.$refs.AuditOpenInput.closeSetTime()
      this.isInput = false;
      this.isSubmit = false      
    },
    // 刷新里面的数据
    retRefresh (e) {
      if (this.list.myreportformid && this.urlObj[2] && this.navIndex === 2) {
        // 如果 e 有数据过来则验证他（这个是针对发起完未填提醒的）
        if (e) {
          // 如果存在提示在去获取一次
          if (e.isEdit) {
            this.getAppInfo(1);
          } else {
            this.repeat = e;
          }
        }

        let self = this;
        this.getapprovalnum();
        this.$nextTick(function () {
          let dom = self.$refs.transactionCenter;
          if (dom) {
            if (Array.isArray(dom)) {
              dom[0].resetRefresh();
            } else {
              dom.resetRefresh();
            }
          }
          self.refreshAllData()
          self.refreshScopeData()
        })
      } else if (this.navIndex === 3) {
        // 个人数据存在权限则重新刷新个人数据里面的数据
        if (this.list.myreportformid && this.urlObj[2]) {
          this.$nextTick(function () {
            let dom = this.$refs.transactionCenter;
            if (Array.isArray(dom)) {
              dom[0].resetRefresh();
            } else {
              dom.resetRefresh();
            }
          })
        }
      }
      if (this.modify || this.navIndex === 6) {
        // 修改数据的话
        /*
            let iframe = this.$refs.iframe3;
            if (iframe && iframe[0]) {
              iframe[0].contentWindow.postMessage({
                cmd: 'getFromJson',
                params: {}
              }, '*')
            }
        */
        let self = this;
        this.$nextTick(function () {
          // self.upUrl(3, true, true);
          self.refreshAllData()
          self.refreshScopeData()
        })
      }
      if (this.navIndex === 6) {
        const dom = this.$refs.transactionCenter;
        if (dom) {
          if (Array.isArray(dom)) {
            dom[0].resetRefresh();
          } else {
            dom.resetRefresh();
          }
        }
      }
      if (this.navIndex === 8) {
        this.refreshAllData()
      }
      const dom = this.$refs.RecycleBin;
      if (dom) {
        if (Array.isArray(dom)) {
          dom[0].getList();
        } else {
          dom.getList();
        }
      }

    },
    // 跳页
    async upUrl (key, isVerify, noTop) {
      console.log('走了这', key, isVerify, noTop);
      if (!key) {
        this.isTops = !this.isTops
        return false;
      }
      const payload = {type: key === 6 ? 4 : key, approvalId: this.approvalId}
      const upaceId = this.isUpace ? (this.$route.query.upaceid || localStorage.getItem('upaceid')) : undefined
      const flag = await isValidateapprovaltimeswitch(payload, upaceId)
      if (flag) return
      // 7 应用任务
      // 这种是单独点击的
      if (key === 7) {
        this.taskEnlarge = false
        this.taskDialog = true
        return false
      }
      let queryData = this.$route.query
      if (Object.keys(this.customDeskInfo).length !== 0) {
        queryData = {
          ...queryData,
          ...this.customDeskInfo
        }
      }
      let { funId } = queryData
      // 提交统计单独提出来
      if (key === 4 && (!funId || funId != 8)) {
        this.statistics = true
        return false
      }
      if ((key === 2 || key === 3) && !noTop) this.upTopFun(key);
      if (key === this.navIndex && !isVerify) {
        return false;
      }
      this.navIndex = key;
      if(key === 1){
        this.notaskShow = true
      }
      if (key > 1 && key < 7 || key === 8) {
        // 重置
        this.urlArr.map(val => {
          val.show = key === val.key;
        })
      }

      if (key === 2) {
        if (!this.urlObj[key]) {
          this.urlObj[key] = key;
          this.urlArr.push({
            key: key,
            // url: '/clientSide/workbench/transactionManagement?approvalId=' + (this.approvalId ? this.approvalId : ''),
            show: true
          })
          let self = this;
          this.$nextTick(function () {
            let dom = this.$refs.transactionCenter;
            let isLeftCount = 0;  // 左列显示的下标个数
            if (dom) {
              let guide = this.guide;
              let key = '';
              if (guide.length > 0) {
                for (let i = 0; i < guide.length; i++) {
                  if (!guide[i].hide) isLeftCount += 1;
                  if (!guide[i].hide && key === '') {
                    key = guide[i].key == 1 ? 0 : guide[i].key == 2 ? 5 : guide[i].key == 3 ? 7 : guide[i].key == 4 ? 6 : 3;
                    guide[i].check = true;
                  } else {
                    guide[i].check = false;
                  }
                }
              }

              this.upListGuide(guide, !key ? 0 : key, isLeftCount)
              // 以下防止下标做兼容
              if (Array.isArray(dom)) {
                // dom[0].upListGuide(guide, !key ? 0 : key, isLeftCount);
                dom[0].getList(self.approvalId);
              } else {
                // dom.upListGuide(guide, !key ? 0 : key, isLeftCount);
                dom.getList(self.approvalId);
              }
            }

          })
        }
      } else if (key === 3) {
        if (!this.urlObj[key]) {
          this.urlObj[key] = key;
          this.urlArr.push({
            key: key,
            show: true
          })
          await this.$nextTick()
          this.refreshAllData(2)
        }
      } else if (key === 6) {
        if (!this.urlObj[key]) {
          this.urlObj[key] = key;
          this.urlArr.push({
            key: key,
            show: true
          })
          await this.$nextTick()
          this.refreshScopeData(3)
        }
      } else if (key === 4) {
        if (!this.urlObj[key]) {
          this.urlObj[key] = key;
          this.urlArr.push({
            key: key,
            url: '/clientSide/workbench/CycleFillingSetting/CycleFillingSetting?approvalId=' + (this.approvalId ? this.approvalId : ''),
            show: true
          })
        }
      } else if (key === 5) {
        if (!this.urlObj[key]) {
          let userMsg = JSON.parse(localStorage.getItem("userMsg"))
          let id = this.approvalId + "_" + userMsg.schoolMsg.schoolId;
          this.urlObj[key] = key;

          let goUrl = '/blockchainNodata?name=本应用未上区块链';
          if (this.blockchainData && this.blockchainData != '') {
            let blockchainData = JSON.parse(this.blockchainData);
            if (blockchainData.chaininstall != 0) {
              goUrl = 'https://open.xmedu.cn/qkl/xmedu/?appid=' + id   // 这个是后台说放 edu 看的
              // goUrl = 'https://ws.dylbc.cn:9061/xmedu/?appid=' + id   这个是老的
            }

          }


          this.urlArr.push({
            key: key,
            url: goUrl,
            show: true
          })
        }
      } else if (key === 8) {
        if (!this.urlObj[key]) {
          this.urlObj[key] = key;
          this.urlArr.push({
            key: key,
            show: true
          })
          await this.$nextTick()
          const ref = this.$refs.RecycleBin
          if (ref[0]) {
            ref[0].init()
          }
        }
      }
    },
    // 刷新全部数据
    refreshAllData (val) {
      const dom = this.$refs.transactionCenters
      if (dom) {
        // whetherShow 初始化 switClick 之刷新列表
        const ff = val ? 'whetherShow' : 'switClick'
        if (dom && dom[0]) {
          dom[0][ff](val)
        } else {
          dom[ff](val)
        }
      }
    },
    // 刷新管辖数据
    refreshScopeData (val) {
      const dom = this.$refs.transactionScope
      if (dom) {
        // whetherShow 初始化 switClick 之刷新列表
        const ff = val ? 'whetherShow' : 'switClick'
        if (dom[0]) {
          dom[0][ff](val)
        } else {
          dom[ff](val)
        }
      }
    },
    // 更新列表权限参数
    upListGuide (guide, key, leftCount) {
      console.log(guide, key, leftCount, 333333333333333);
      if (leftCount <= 1) this.isTop = false;
      if (guide && guide.length > 0) {
        this.listAuthority = guide;
      } else {
        this.isTop = true;
        this.listAuthority = [
          {
            name: '填报记录',
            check: true,
            key: 1,
            count: '',
            hide: false,
          },
          {
            name: '待我处理',
            check: false,
            key: 2,
            hide: false,
          },
          {
            name: '待阅',
            check: false,
            key: 3,
            hide: false,
          },
          {
            name: '我已处理',
            check: false,
            key: 4,
            hide: false,
          },
          {
            name: '关于我的',
            check: false,
            key: 5,
            hide: false,
          },
        ];
      }
      this.activeName = key;
      // 给下一页赋值初始值
      const index = this.listAuthority.filter(item => { return item.check ? item.key : false })
      // 对应显示转换
      const obj = {
        1: 0,
        5: 3,
        2: 1,
        4: 2,
        3: 7
      }
      const id = this.$route.query.iId || this.customDeskInfo.iId
      if (id) {
        switch (id) {
          case '1':
            this.setActive(0)
            break;
          case '2':
            this.setActive(1)
            break;
          case '3':
            this.setActive(7)
            break;
          case '4':
            this.setActive(2)
            break;
          case '5':
            this.setActive(3)
            break;
        }
      } else {
        this.setActive(obj[index[0].key])
      }
    },
    setActive (value) {
      const dom = this.$refs.transactionCenter
      if (dom[0] && dom[0].inquire) {
        dom[0].$data.activeName = value
      } else {
        dom.$data.activeName = value
      }
    },
    // 获取红点数据
    getapprovalnum() {
      if (this.external) return;
      const obj = { number: 1, approvalId: this.approvalId }
      // 从空间进入，需要传空间id
      if(this.isSpace){
        const spaceId = this.$route.query.spaceid || localStorage.getItem('spaceid')
        obj.spaceid = spaceId;
      }
      else if(this.isUpace){
        const upaceId = this.$route.query.upaceid || localStorage.getItem('upaceid')
        obj.upaceid = upaceId;
      }
      openapiGetapprovalnum(obj).then(res => {
        if (res.code === 0) {
          this.listCount = res.data;
        }
      }).catch(err => {
        console.log(err)
      })
    },

    // 初始化（直接打开当前页面的） key 为1 则是只需要获取周期验证
    getAppInfo(key) {
      const spaceid = this.$route.query.spaceid
      const upaceid = this.$route.query.upaceid
      const __par = { approvalId: this.approvalId, number: 1 }
      if (spaceid) {
        __par.spaceid = spaceid
      }
      else if (upaceid) {
        __par.upaceid = upaceid
      }
      openapiGetapproval(__par).then(async res => {
        if (res.code === 0) {
          if (key === 1) {
            this.repeat = res.data.repeat;
            return;
          }
          const property = JSON.parse(res.data.property)
          this.property = property
          const fileProperty = {}
          property.forEach(item => {
            fileProperty[item.title] = item  
          })
          this.fileProperty = fileProperty
          if (this.isBatchAddPage) {
            let addbatchs = res.data.addbatchs
            let addconfig = res.data.addconfig
            let variableconfig = res.data.variableconfig
            if (variableconfig && typeof variableconfig === 'string') {
              variableconfig = JSON.parse(variableconfig)
              let paramsList = this.queryData.paramsList || []
              paramsList = typeof paramsList === 'string' ? JSON.parse(paramsList) : paramsList
              for (const ele of variableconfig) {
                const item = paramsList.find(item => item.name === ele.name)
                if (item) {
                  ele.value = item.value
                }
              }
              this.customData = variableconfig
            }
            if (addbatchs && typeof addbatchs === 'string') {
              addbatchs = JSON.parse(addbatchs)
              const info = addbatchs.find(item => item.id === this.queryData.iId)
              if (info) {
                this.batchAddInfo = info.config
                this.batchAddStyle = info.style
              }
            }
            if (addconfig && typeof addconfig === 'string') {
              addconfig = JSON.parse(addconfig)
              this.animationStyle = addconfig.animationStyle || {}
            }
            return
          }
          if (res.data.baseset) {
            const baseset = JSON.parse(res.data.baseset)
            if (baseset.importSet) {
              this.importSet = baseset.importSet
            }
          }
          // ai 是否给打开的
          this.isAi = res.data.openai || 0
          this.pdwidth = res.data.pdwidth || 75

          let obj = {};
          let permissionlist = res.data.permissionlist || [];
          for (let i = 0; i < permissionlist.length; i++) {
            obj[permissionlist[i].key] = permissionlist[i].key;
          }
          let guide = [
            {
              name: '填报记录',
              check: true,
              key: 1,
              count: '123',
              hide: false,
            },
            {
              name: '待我处理',
              check: false,
              key: 2,
              hide: false,
            },
            {
              name: '我已处理',
              check: false,
              key: 4,
              hide: false,
            },
            {
              name: '待阅',
              check: false,
              key: 3,
              hide: false,
            },
            {
              name: '关于我的',
              check: false,
              key: 5,
              hide: false,
            },
          ];
          if (res.data.guide) {
            try { guide = JSON.parse(res.data.guide) }
            catch (err) { console.log('转码出错', err) }
          }
          if (this.external) {
            // 删掉几个固定的
            for (let i = 0; i < guide.length; i++) {
              if (guide[i].key > 1 && guide[i].key < 5) {
                guide[i].hide = true;
              }
            }
          }
          if (this.blockchainData === '' && obj['blockchainid'] && res.data.blockchain) {
            //- 当首页直接进入该表单页面是没有走getallbycategoryandfolder接口的，所以需要加这个判断
            // eslint-disable-next-line vue/no-mutating-props
            this.blockchainData = res.data.blockchain

          }
          this.getCompone(obj, res.data.approvalId, res.data.appname, guide, res.data.repeat);

          // 判断是否是自定义页面
          if (res.data && res.data.pageset) {
            let pageset = JSON.parse(res.data.pageset)
            if (pageset && pageset.url) {
              pageset = await getConfigFromUrl(this.$url + pageset.url)
            }
            if (!Array.isArray(pageset)) {
              console.log("详情页配置格式错误：", pageset)
            }
            if(Array.isArray(pageset) && pageset[0] && pageset[0].config && pageset[0].config[4] && pageset[0].config[4].custom === 1 && pageset[0].config[4].listConfig){
              this.customPageConfig = isJSON(pageset[0].config[4].listConfig)
              this.customPage = true;
              // 判断是否有设置单页面
              const id = this.$route.query.iId || this.customDeskInfo.iId
              if(id !== undefined && Number(id) <= 7){
                this.customPageConfig.pageId = id
                this.customPageConfig.info.navbarConfig.action = 'hidden'
              }
            }
          }
        }
        this.isView = true;
      }).catch(() => {
        this.isView = false;
      })
    },

    // 根据 list 选择初始选中位置
    selectNav (val) {
      const list = this.list;
      if (this.$route.query.iId ||  this.customDeskInfo.iId) {
        let queryData = this.$route.query
        if (Object.keys(this.customDeskInfo).length !== 0) {
          queryData = {
            ...queryData,
            ...this.customDeskInfo
          }
        }
        let { pageId, dataId, addId } = queryData
        if ((list.approvalid && !list.myreportformid && !list.reportFormid) || (this.external && list.approvalid)) {
          this.navIndex = 1;
          this.notaskShow = false;
        } else if (pageId || addId == 12 || addId == 11) {
          if (list.myreportformid) {
            this.upUrl(2, false, val);
          } else {
            this.$message.warning('你没有权限')
          }
        } else if (list.scopeid && dataId == 6) {
          // 管辖数据
          this.upUrl(6, false, val)
        } else if (dataId) {
          if (list.reportFormid) {
            // 全部数据
            this.upUrl(3, false, val);
          } else {
            this.$message.warning('你没有权限')
          }
        } else if (list.uncompleteid) {
          this.upUrl(4);
        }
      } else {
        if ((list.approvalid && !list.myreportformid && !list.reportFormid) || (this.external && list.approvalid)) {
          this.navIndex = 1;
          this.notaskShow = false;
        } else if (list.myreportformid) {
          this.upUrl(2, false, val);
        } else if (list.reportFormid) {
          this.upUrl(3, false, val);
        } else if (list.uncompleteid) {
          this.upUrl(4);
        } else if (list.scopeid) {
          this.upUrl(6, false, val)
        }
      }
    },
    // 当前页面以组建形式传入数据 list 权限列表 id approvalId
    getCompone (list, id, name, guide, repeat, batch) {
      // 初始化各项值
      this.isView = false;
      this.list = list;
      this.approvalId = id;
      this.urlArr = [];
      this.urlObj = {};
      this.navIndex = 1;
      this.repeat = {};
      this.guide = [];
      this.name = name;
      this.isTop = false;
      this.listAuthority = [];
      this.activeName = 0;
      this.batchadd = batch === 1

      // 读取应用列表红点
      if (this.isUpace) {
        const upaceId = this.$route.query.upaceid || localStorage.getItem('upaceid')
        this.$store.commit('getTaskHint', { approvalId: id, upaceId })
      } else {
        this.$store.commit('getTaskHint', { approvalId: id })
      }

      if (guide) {
        this.guide = typeof guide === 'string' ? JSON.parse(guide) : guide;
      }
      if (repeat) this.repeat = repeat;
      this.isView = true;
      this.selectNav(true);
      this.getapprovalnum();
    },
    iframeAreadys () {
      this.iframeLoading = false;
    },
		// 获取AI小易开启状态
		async getManagementList(){
			const obj = { curpage: 0, pagesize: 0, type: this.abilityType }
      obj.name = '人工智能查询'
      if (this.$route.query.upaceid || (this.$route.query.upace && localStorage.getItem('upaceid'))) {
        obj.upaceid = this.$route.query.upaceid || localStorage.getItem('upaceid')
      }
			const { data } = await axiosBase(obj, "/api/getcompetencymanagelist")
			console.log(data)
			if(data){
				let status = data[0]['status']
				console.log(status)
				this.aiStatus = status ? true : false
			}
		},
    addMask() {
      // 检查遮罩层元素是否已经存在
      const existingMask = document.getElementById('j-mask-dialogA');
      if (existingMask) {
        // 如果遮罩层已经存在，跳过创建步骤
        return;
      }
      // 创建遮罩层元素
      const mask = document.createElement('div');
      mask.id = 'j-mask-dialogA';
      mask.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        z-index: 99;
        transition: opacity 0.3s;
        opacity: 0;
      `;
      // 使用 setTimeout 模拟遮罩层渐变效果
      setTimeout(() => {
        mask.style.opacity = 1;
      }, 10);
      
      // 将遮罩层添加到 body
      document.body.appendChild(mask);
      
      // 点击遮罩层关闭弹窗
      mask.onclick = () => {
        this.showModal = false;
      };
    },
    removeMask() {
      // 获取遮罩层元素
      const mask = document.getElementById('j-mask-dialogA');
      if (mask) {
        // 使用 setTimeout 模拟遮罩层渐变效果
        mask.style.opacity = 0;
        setTimeout(() => {
          document.body.removeChild(mask);
        }, 300); // 300ms 后删除遮罩层
      }
    },
  },
  unmounted () {
    const temporaryToken = sessionStorage.getItem('temporaryToken')
    if (temporaryToken) sessionStorage.removeItem('temporaryToken')
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/clientSide/applicationRouting.scss';

::v-deep html,
::v-deep body,
::v-deep #app {
  height: 100%;
}
::v-deep .el-dialog.is-fullscreen {
  overflow: hidden;
}

.batch-add {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  &-btn {
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.active-hover:hover {
  color: #4e86ff;
  i {
    color: #4e86ff;
  }
}
// pc弹窗高度-自适应
:deep(.dialog-height-auto) {
  min-height: inherit;
  .oaExamineInput {
    position: inherit;
    .oaExamineAllArea {
      .wisdomSubmit {
        .wisdomSubmitBox {
          position: inherit;
        }
      }
    }
  }
}

/*修改滚动条样式*/
::v-deep .application-routing-dialog-all::-webkit-scrollbar {
  position: absolute;
  right: 0;
  top: 0;
  width: 10px;
  height: 10px;
  z-index: 999;
  /**/
}

::v-deep .application-routing-dialog-all::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 2px;
}

::v-deep .application-routing-dialog-all::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  // background: rgba(255 ,253,246, 0.9);
  border-radius: 10px;
}

::v-deep .application-routing-dialog-all::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.5);
}

::v-deep .application-routing-dialog-all::-webkit-scrollbar-corner {
  background: transparent;
}
.task-routing-title {
  position: relative;
  line-height: 20px;
  .title-title {
    font-size: 14px;
    font-weight: 600;
    color: #333333;
  }
  .task-icon {
    position: absolute;
    right: 20px;
    top: 0;
    color: #999999;
    font-size: 14px;
    font-weight: 400;
    cursor: pointer;
  }
}
.mom-button {
  font-size: 16px;
  color: #333333;
  cursor: pointer;
  margin-left: 20px;
  .icon-gengduo {
    color: #999999;
    font-size: 12px;
    margin-left: 7px;
  }
  .icon-round {
    width: 8px;
    height: 8px;
    background: #e47470;
    border-radius: 50%;
    margin-right: 7px;
    display: inline-block;
  }
}
.mom-block {
  padding-top: 6px;
  padding-bottom: 6px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 4px;
  .mom-block-list {
    cursor: pointer;
    padding-top: 6px;
    padding-bottom: 6px;
    padding-left: 26px;
    color: #ffffff;
    position: relative;
    &:hover {
      background: rgba(241, 248, 255, 0.12);
    }
    .icon-round {
      width: 8px;
      height: 8px;
      background: #e47470;
      border-radius: 50%;
      display: inline-block;
      position: absolute;
      left: 10px;
      top: 12px;
    }
  }
  .active {
    background: rgba(241, 248, 255, 0.12);
  }  
}

.rout-opendialog>.el-dialog__wrapper {
  opacity: 0 !important;
}
.dialog-top-black {
  background: #000;
  border-bottom: 1px solid #000;
  .apply-name {
    color: #fff;
  }
  .apply-right {
    color: #fff;
    &>div{
      border-left: 1px solid #333;
    }
  }
}
.dialog-top-black-close {
  z-index: 1999;
}
</style>
<style lang="scss">
.task-Routing {
  padding: 0 !important;
  transition: 0.3s;
  .el-dialog__header {
    padding: 8px 16px;
    .el-dialog__headerbtn {
      right: 20px;
      top: 8px;
      font-size: 20px;
      width: auto;
      height: auto;
    }
  }
  .el-dialog__body {
    padding: 0;
    /*height: 605px;*/
  }
}
</style>
